module.exports = __webpack_public_path__ + "static/Chic_&_Secluded_Banner.9b76b942.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Chic_&_Secluded_Banner.jpg
// module id = 51
// module chunks = 35783957827783 174759553322802 227638899823042